if (!customElements.get("comp-product-hero")) {
  class CompProductHero extends HTMLElement {
    constructor() {
      super();
      this.group = this.dataset.group;
      this.coreColors = this.dataset.coreColors;
      this.variantContainer = this.querySelector("#variant-swatch-container");

      this.colorButtons = [...this.querySelectorAll('.color-btn')];
      this.variantOptions = [...this.querySelectorAll('[data-variant-option]')];

      // Gallery
      this.galleryMain = this.querySelector('.product-main-image-splide');
      this.galleryThumb = this.querySelector('.product-thumbnail-image-splide');
      this.arrowRight = this.querySelector('[data-gallery-before]')
      this.arrowNext = this.querySelector('[data-gallery-next]')
      this.galleryArrows = [...this.querySelectorAll('.product-main-image__arrow')]
      this.thumbContainer = this.querySelector(".product-thumbnail-image-splide");

      this.needUpdateElements = [
        { source: '.section-visual-usp', target: '.section-visual-usp' },
        { source: '.section-pdp-blog-story', target: '.section-pdp-blog-story' }
      ]
    }

    connectedCallback() {
      if (this.group) {
        this.buildColorSwatches();
        if (this.variantContainer) {
          this.variantContainer.addEventListener("click", (e) => this.handleColorClick(e));
        }
      }

      this.colorButtons.forEach((swatch)=>{
        swatch.addEventListener("click",(e)=>{
          this.querySelectorAll(".product-variants").forEach((el)=>{
            if ( el.querySelector(".product-variants-label")) {
              el.querySelector(".product-variants-label").innerHTML = '';
            }
          });
          e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML = swatch.getAttribute("data-swatch-color");
        });
        swatch.addEventListener("mouseOver", (e)=>{
          e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML = swatch.getAttribute("data-swatch-color");
        });
        swatch.addEventListener("mouseOut",(e)=>{
          e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML ='';
        })
      });

      this.variantOptions.forEach((btn) => {
        btn.addEventListener('click', (e) => this.handleVariantClick(e));
      })

      this.initGallery()
      this.initSizeGuide()
    }

    buildColorSwatches() {

      fetch(window.api_url, {
        method: 'POST',
        'crossDomain': true,
        headers: {
          'X-Shopify-Storefront-Access-Token': window.api_key,
          "Content-Type": "application/json"
        },

        body: JSON.stringify({
          query: `query @inContext(country: ${Shopify.country}) {
                    products(query: "tag:'${this.group}'", first: 20, sortKey: TITLE) {
                      edges {
                        node {
                          id
                          title
                          handle
                          tags
                          exclude: metafield(namespace: "c_f", key: "exclude_colors_for_online") {
                            value
                          }
                          badge: metafield(namespace: "custom_fields", key: "merchandising_message_tag"){value}
                          bundle_setting: metafield(namespace: "custom", key: "bundle_setting"){
                            reference {
                              ... on Metaobject {
                                id
                                fields {
                                  key
                                  value
                                }
                              }
                            }
                          }
                          model_info: metafield(namespace: "custom", key: "model"){
                            reference {
                              ... on Metaobject {
                                id
                                fields {
                                  key
                                  value
                                }
                              }
                            }
                          }
                          media(first: 30) {
                            edges {
                              node {
                                alt
                                mediaContentType
                                previewImage {
                                  id
                                  url
                                }
                              }
                            }
                          }
                          variants(first: 20) {
                            edges {
                              node {
                                availableForSale
                                price{
                                  amount
                                }
                                compareAtPrice{
                                  amount
                                }
                                title
                                id
                                quantityAvailable
                                sku
                              }
                            }
                          }
                        }
                      }
                    }
                  }`
        })
      })
      .then((response) => response.json())
      .then((data) => {
        this.data = data.data.products.edges;
        var vSpecial='', vNormal ='';

        for (var i = 0; i<this.data.length; i++){
          var markup = '';
          var product = this.data[i].node;
          if(product.media.edges[0] == undefined){
            continue;
          }
          var isFinalSale = false;
          if (product.tags.includes('final-sale')) {
            isFinalSale = true;
          }
          var title = product.variants.edges[0].node.title;
          title = title.substring(0, title.lastIndexOf('/ ') - 1).trim();
          if (product.exclude != null){
            if(product.exclude.value.includes(title)){
              continue;
            }
          }
          var active = false
          markup += `
          <button type="button" style="background-image: url(${window.theme.assetLink}color-${title.toLowerCase().replaceAll(" ", "-").replaceAll('/','-')}_35x.png)" aria-label="${title} color selector" class="color-btn`;
          if(this.dataset.handle == product.handle){
            markup += ` active`;
            active = true;
          }
          markup += `"
          data-swatch-image='${product.media.edges[0].node.previewImage.url}'
          data-url='/products/${product.handle}'
          data-index='${i}'
          data-product-id='${product.id.replace("gid://shopify/Product/", "")}'
          data-swatch-id='${product.variants.edges[0].node.id.replace("gid://shopify/ProductVariant/", "")}'
          data-swatch-badge="${product.badge?.value}"
          data-swatch-color='${title}'
          data-is-final-sale='${isFinalSale}'
          data-price='${product.variants.edges[0].node.price.amount}'`;
          if(product.variants.edges[0].node.compareAtPrice != null){
            markup+=` data-comp-price='${product.variants.edges[0].node.compareAtPrice.amount}'`;
          }
          markup += `arial-label='${title}'></button>`;
          const swatchNormalLabel = this.querySelector(".swatch-normal .product-variants-label");
          const swatchSpecialLabel = this.querySelector(".swatch-special .product-variants-label");
          if (this.coreColors.indexOf(title) > -1){
            if (active){
              if (swatchNormalLabel) {
                swatchNormalLabel.innerHTML = title;
              }
              if (swatchSpecialLabel) {
                swatchSpecialLabel.innerHTML = ''
              }
            }
            vNormal += markup;
          }else{
            if (active){
              if (swatchSpecialLabel) {
                swatchSpecialLabel.innerHTML = title;
              }
              if (swatchNormalLabel) {
                swatchNormalLabel.innerHTML = '';
              }
            }
            vSpecial += markup;
          }
        }
        if(vNormal.length > 0){
          if (this.querySelector(".swatch-list-normal")) {
            this.querySelector(".swatch-list-normal").innerHTML = vNormal;
          }
          if (this.querySelector('.swatch-normal')) {
            this.querySelector('.swatch-normal').style.display='';
          }
        }else{
          if (this.querySelector('.swatch-normal')) {
            this.querySelector('.swatch-normal').style.display='none';
          }
        }
        if(vSpecial.length > 0){
          if (this.querySelector(".swatch-list-special")) {
            this.querySelector(".swatch-list-special").innerHTML = vSpecial;
          }
          if (this.querySelector('.swatch-special')) {
            this.querySelector('.swatch-special').style.display='';
          }
        }else{
          if (this.querySelector('.swatch-special')) {
            this.querySelector('.swatch-special').style.display='none';
          }
        }
        //preload images into the browser cache
        let preImg = new Image();
        this.data.forEach((a)=>{
          a.node.media.edges.forEach((i)=>{
            preImg.src = i.node.previewImage.url.replace(/(\.[\w\d_(?=\?)-]+)$/i, '_188x$1');
            preImg.src = i.node.previewImage.url;
          });
        });
      }).then(()=>{

        this.querySelectorAll('.color-btn').forEach((swatch)=>{
          let previousTitle = '';
          swatch.addEventListener("click", (e)=>{
            previousTitle = swatch.getAttribute("data-swatch-color");

            const productId = swatch.getAttribute('data-product-id');
            const waitlistProductId = this.querySelector('.product-waitlist [name="waitlist-product-id"]');

            const badgeElem = this.querySelector('.product-badge')
            
            if (badgeElem) {
              if (swatch.dataset.swatchBadge != 'undefined') {
                badgeElem.innerHTML = swatch.dataset.swatchBadge
                badgeElem.classList.add('show')
              } else {
                badgeElem.classList.remove('show')
              }
            }
            waitlistProductId.value = productId;
          });

          swatch.addEventListener("mouseenter", (e)=>{
            previousTitle = e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML;
            e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML = swatch.getAttribute("data-swatch-color");
          });
          swatch.addEventListener("mouseleave",(e)=>{
            e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML = previousTitle;
          });
        });

        // Click First active color button after the color buttons are rendered.
        $('#variant-swatch-container .color-btn.active').click()
      });
    }

    handleColorClick(e) {
      if (e.target.closest(".color-btn")) {
        let selectedSwatch = this.data[e.target.getAttribute("data-index")].node;
        this.querySelectorAll("#variant-swatch-container .color-btn").forEach((e) =>{
          e.classList.remove("active");
        })
        let colorBtn = e.target.closest(".color-btn");
        this.querySelectorAll("#variant-swatch-container .product-variants").forEach((el)=>{
          if ( el.querySelector(".product-variants-label")) {
            el.querySelector(".product-variants-label").innerHTML = '';
          }
        });
        colorBtn.closest(".product-variants").querySelector(".product-variants-label").innerHTML = colorBtn.getAttribute("data-swatch-color");

        const targetUrl = colorBtn.getAttribute('data-url');
        if (location.href.indexOf('/products/') > 0) {
          history.replaceState(null, '', targetUrl);
        }

        let index = parseInt(colorBtn.getAttribute('data-index'));
        let variants = this.data[index].node.variants.edges;
        colorBtn.classList.add("active");

        // Update Final Sale
        const finalSale = colorBtn.dataset.isFinalSale;
        const elems = [...this.querySelectorAll('.product-final-sale')];
        elems.map((elem) => {
          if (finalSale == 'true') {
            elem.classList.remove('hide')
          } else {
            elem.classList.add('hide')
          }
        })

        console.log(selectedSwatch.model_info);
        // Update Model Info
        const modelInfoElem = this.querySelector('[data-model-info]');
        if (selectedSwatch.model_info != null) {
          let modelInfoHtml = '';
          selectedSwatch.model_info.reference?.fields.forEach((info) => {
            if (info.key == 'height') {
              modelInfoHtml += `Model is ${info.value}`
            } else if (info.key == 'size') {
              modelInfoHtml += ` in size ${info.value}`
            }
          })

          if (modelInfoElem) {
            modelInfoElem.innerHTML = modelInfoHtml;
            modelInfoElem.classList.remove('hide');
          }
        } else {
          if (modelInfoElem) {
            modelInfoElem.classList.add('hide');
          }
        }

        // Update Bundle Message
        if (selectedSwatch.bundle_setting != null) {
          const message = selectedSwatch.bundle_setting.reference?.fields.find(f => f.key == 'discount_message')?.value || ''
          const message_mobile = selectedSwatch.bundle_setting.reference?.fields.find(f => f.key == 'discount_message_mobile')?.value || ''

          const messageElem = this.querySelector('[data-product-bundle-msg]');
          const messageElemMobile = this.querySelector('[data-product-bundle-msg-mobile]');

          if (messageElem) {
            messageElem.innerHTML = message
            messageElem.classList.remove('hide')
          }

          if (messageElemMobile) {
            messageElemMobile.innerHTML = message_mobile
            messageElemMobile.classList.remove('hide')
          }
        } else {
          const messageElem = this.querySelector('[data-product-bundle-msg]');
          const messageElemMobile = this.querySelector('[data-product-bundle-msg-mobile]');

          if (messageElem) {
            messageElem.classList.add('hide')
          }

          if (messageElemMobile) {
            messageElemMobile.classList.add('hide')
          }
        }

        // Rebuild Size Options
        this.querySelectorAll("#product-sizes ul li").forEach((e, i)=>{
          let variant = e.querySelector(".size-btn");
          let variantInfo = e.querySelector(".variant-info");
          let varId = variants[i].node.id.replace("gid://shopify/ProductVariant/", "");
          let variantPrice = parseFloat(variants[i].node.price.amount),
            comparePrice = variants[i].node.compareAtPrice ? parseFloat(variants[i].node.compareAtPrice.amount) : 0;

          if(!variants[i].node.availableForSale){
            variant.classList.add("sold-out");
            variantInfo.querySelector(".cr-red").innerHTML = "SOLD OUT";
          } else {
            if(variants[i].node.quantityAvailable < 10) {
              variantInfo.querySelector(".cr-red").innerHTML = `ONLY ${variants[i].node.quantityAvailable} LEFT`;
            } else {
              variantInfo.querySelector(".cr-red").innerHTML ='';
            }
            variant.classList.remove("sold-out");
          }
          
          variant.setAttribute("data-variant-id", varId);
          variant.setAttribute("data-quantity-avail", variants[i].node.quantityAvailable);
          variant.setAttribute("data-variant-sku", variants[i].node.sku);
          variant.setAttribute("data-variant-price", formatMoney(variantPrice));

          if (comparePrice) {
            variant.setAttribute("data-variant-compare-price", comparePrice);
          }

          variant.setAttribute("data-variant-dy-price", variantPrice.toFixed(2));

          if (window.theme?.member_discount) {
            const memberPrice = variantPrice * (100 - parseFloat(window.theme?.member_discount)) / 100.0;
            variant.setAttribute("data-variant-ms-price", formatMoney(memberPrice));
          }

          if(variant.classList.contains("active")){
            this.querySelector("#add-to-cart-btn").setAttribute("data-quickadd-id", varId);
          }
        });

        // Click first active size option
        if (this.querySelector("#product-sizes .size-btn.active")) {
          this.querySelector("#product-sizes .size-btn.active").click();
        }

        this.updateContent(targetUrl);
      }
    }

    handleVariantClick(e) {
      console.log(e.target)
      let _this = e.target.closest("[data-variant-option]");
      let addToBagButtons = document.querySelectorAll('#sticky-header-cta button[type="submit"], #add-to-cart-btn');
      let waitlist = this.querySelector(".product-waitlist");
      let heroFormSubmit = this.querySelectorAll('#product-hero-form [data-quickadd-id] ,#additional-checkout-buttons');
      let personalize = this.querySelector(".personalize-link");

      if(_this.classList.contains("sold-out")) {
        addToBagButtons.forEach(button => {
          button.setAttribute('data-sold-out', '');
          button.innerHTML = "Join Waitlist";
        });

        if (typeof _this.dataset.bisHidden === 'undefined') {
          // If product doesn't have bis-hidden tag, hide the CTA
          heroFormSubmit.forEach((e)=>{
            e.style.display = "none";
          })
        }
        if (personalize) {
          personalize.style.display = "none";
        }

        if (waitlist) {
          waitlist.classList.remove('success');
          waitlist.style.display = "";
        }

        // update wishlist button variant ID
        const waitlistVariantId = this.querySelector('.product-waitlist [name="waitlist-variant-id"]');
        if (waitlistVariantId) {
          waitlistVariantId.value = _this.dataset.variantId;
        }
      } else {
        addToBagButtons.forEach(button => {
          button.disabled = false;
          button.innerHTML = "Add to bag";
        });

        heroFormSubmit.forEach((e)=>{
          e.style.display = "";
        })
        if (personalize) {
          personalize.style.display = "";
        }

        if (waitlist) {
          waitlist.classList.remove('success');
          waitlist.style.display = "none";
        }
      }

      const productPrices = [...document.querySelectorAll('[data-product-price-single]')];
      productPrices.forEach((element) => {
        element.innerHTML = _this.getAttribute('data-variant-price');
      })
  
      const membershipPrices = [...document.querySelectorAll('[data-product-member-price]')];
      membershipPrices.forEach((element) => {
        element.innerHTML = _this.getAttribute('data-variant-ms-price');
      })

      const comparePrices = [...this.querySelectorAll('[data-product-price-compare]')];
      if (_this.getAttribute('data-variant-compare-price') != null) {
        comparePrices.forEach((priceElement) => {
          const price = parseFloat(_this.getAttribute('data-variant-compare-price'));
          if (price == 0) {
            priceElement.classList.add('hide')
          } else {
            priceElement.innerHTML = formatMoney(price);
            priceElement.classList.remove('hide')
          }
        })
      }
    }

    updateContent(url) {
      fetch(url)
        .then((response) => {
            // When the page is loaded convert it to text
            return response.text()
        })
        .then((html) => {
            // Initialize the DOM parser
            var parser = new DOMParser();

            // Parse the text
            var doc = parser.parseFromString(html, "text/html");

            this.needUpdateElements.forEach((item) => {
              const visualUSP = doc.querySelector(item.source);
              const currentUSP = document.querySelector(item.target);
              if (visualUSP && currentUSP) {
                currentUSP.innerHTML = visualUSP.innerHTML

                // Add callback event
              }
            })

        })
        .catch((err) => {  
            console.log('Failed to fetch page: ', err);  
        });
    }

    initSizeGuide() {
      let wrap = this.querySelector('.product-size-guide');
      if (this.closest('product-drawer')) {
        wrap = this.closest('product-drawer').nextElementSibling
      }
      const guideOpen = [...this.querySelectorAll('.size-guide-open')];
      const guideClose = [...wrap.querySelectorAll('[data-size-guide-close]')];
      const fitSelector = wrap.querySelector('#size-guide-fit-selector');
      const tabSelector = [...wrap.querySelectorAll('[data-size-chart-tabs-trigger]')];

      guideOpen.forEach((el) => {
        el.addEventListener('click', (evt) => {
          document.documentElement.classList.add('size_guide_active');
          wrap.classList.add('active');
          let index = evt.currentTarget.dataset.index;
          if(index != undefined){
            wrap.querySelectorAll(".size-content .kit_container").forEach((e)=>{
              e.classList.remove("active");
            });
            wrap.querySelector(`.kit_container[data-index='${index}']`).classList.add("active");
          }
        });
      })

      guideClose.forEach((el) => {
        el.addEventListener('click', () => {
          document.documentElement.classList.remove('size_guide_active');
          wrap.classList.remove('active');
        });
      })

      if (fitSelector) {
        fitSelector.addEventListener('change', () => {
          wrap.querySelector('[data-fit].active').classList.remove('active');
          wrap.querySelector(`[data-fit="${fitSelector.value}"]`).classList.add('active');
        });
      }

      tabSelector.forEach((el) => {
        el.addEventListener('click', (e) => {
          const target = e.currentTarget;
          
          $(target).closest('li').addClass('active')
            .siblings().removeClass('active');

          const $tab = $(wrap.querySelector(`[data-size-chart-tabs="${$(target).attr('data-size-chart-tabs-trigger')}"]`));
          $tab.addClass('active').siblings().removeClass('active');
        });
      })
    }

    initGallery() {
      let galleryOptions = {
        rewind: true,
        pagination: false,
        fixedHeight: false,
        width:'100%',
        arrows: false,
        breakpoints: {
          640: {
            padding: {
              right: '10%'
            },
            gap: 11,
            rewind: false,
            fixedHeight: 395
          }
        }
      };
      let thumbnailOptions = {
        width: '94px',
        heightRatio:1,
        isNavigation: true,
        gap: 15,
        pagination: false,
        direction: 'ttb',
        height: '740px',
        arrows: false,
        autoHeight: true,
        breakpoints: {
          1100: {
            height: '400px'
          },
          1440: {
            height: '500px'
          }
        }
      };
      let popupGalleryOptions = {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false,
        drag: true,
        breakpoints: {
          991: {
            arrows: true,
            drag: false
          }
        }
      };
      let popupThumbnailOptions = {
        isNavigation: true,
        gap: 15,
        pagination: false,
        direction: 'ttb',
        height: 700,
        autoHeight: true,
        arrows: false,
      };

      //init gallery
      var galleryMain = new Splide(this.galleryMain, galleryOptions );
      var galleryThumb = new Splide(this.galleryThumb, thumbnailOptions );
      if(this.querySelector(".product-images-popup-main-splide") != null) {
        var popupMain = new Splide('.product-images-popup-main-splide', popupGalleryOptions);
        var popupThumb = new Splide('.product-images-popup-thumbnail-splide', popupThumbnailOptions);
      }

      galleryMain.sync(galleryThumb);
      galleryMain.mount();
      galleryThumb.mount();

      if(popupMain){
        popupMain.sync(popupThumb);
        const popupMainSlide = popupMain.mount();
        popupThumb.mount();

        popupMainSlide.on( 'moved', (newIndex, prevIndex) => {
          const currentSlide = this.querySelector('[data-popup-current-slide]');
          if (currentSlide) {
            currentSlide.textContent = newIndex + 1;
          }
        } );
      }

      let prodImages = this.querySelector('[data-product-images]') ? JSON.parse(this.querySelector('[data-product-images]').innerHTML) : false;
      //scroll gallery thumbnail on arrow click, but do not update active gallery image
      this.galleryArrows.forEach((e)=> {
        e.addEventListener("click", (e) => this._handleGalleryArrowClick(e));
      });

      //Determine if there are alternate sizes
      let altSizes, imageList;
      const getAltSizes = (selectedColor) =>{
        for (let i = 0; i <prodImages.length; i++){
          if(prodImages[i].image_color == selectedColor){
            var image_alt = prodImages[i].image_alt;
            if(image_alt.lastIndexOf("Size:") > -1 ){
              altSizes = image_alt.substring( image_alt.lastIndexOf("Size:") + 5, image_alt.lastIndexOf("@")).split(",");
              break;
            }
          }
        }
      }

      if( this.querySelector(".product-variants .swatch-list .active") != null) {
        getAltSizes(this.querySelector(".product-variants .swatch-list .active").getAttribute("data-swatch-color"));
      }

      //rebuild gallery
      const rebuildSplide = () =>{
        galleryThumb.remove('.splide__slide');
        galleryMain.remove('.splide__slide');
        if(popupMain){
          popupThumb.remove('.splide__slide');
          popupMain.remove('.splide__slide');
        }
        if(imageList.length > 3){
          this.querySelector('.product-main-image__arrow.arrow--next').classList.remove("hide");
        }

        const updateZoomHtml = (element) => {
          let html = `${element}`
          return html;
        }
        
        imageList.forEach((image) => {
          var image_url = image?.image_url,
              image_alt = image?.image_alt;
            galleryThumb.add(`<li class="splide__slide"><img class="product-gallery-thumbnail-image"
              src="${image_url.replace(/(\.[\w\d_(?=\?)-]+)$/i, '_188x$1')}" alt="${image_alt}"></li>`);

            if(popupThumb){
              popupThumb.add(`<li class="splide__slide"><img src="${image_url}" alt="${image_alt}"></li>`);
            }
            if (image_alt.includes('iframe')) {
              galleryMain.add("<li class=\"splide__slide\">".concat(image_alt, "</li>"));
      
              if(popupMain){
                popupMain.add(`<li class="splide__slide">${updateZoomHtml(image_alt)}</li>`);
              }
            } else {
              galleryMain.add(`<li class="splide__slide"><img class="product-main-image" src="${image_url}" alt="${image_alt}"></li>`);

              if(popupMain){
                popupMain.add(`<li class="splide__slide">${updateZoomHtml(`<img src="${image_url}" data-zoom-image alt="${image_alt}">`)}</li>`);
              }
            }
        });
      }

      const buildImageList = (selectedColor, selectedSize) =>{
        getAltSizes(selectedColor);
        let filterImages = prodImages.filter((image) => {
          if(image.image_alt.includes("iframe"))return true;
          return image.image_color == selectedColor;
        });
        let altSize = filterImages.some(i => i.image_alt.includes('Size:'));
        imageList = filterImages.filter((image) => {
          if(image.image_alt.includes("iframe"))return true;

          if(altSizes && altSizes.length > 0 && altSize){
            if(altSizes.includes(selectedSize)){
              return image.image_color == selectedColor && image.image_alt.indexOf("Size:") > -1;
            }else{
              return image.image_color == selectedColor && image.image_alt.indexOf("Size:") < 0;
            }
          }else{
            return true;
          }
        });
        rebuildSplide();
      }

      this.querySelectorAll(".size-btn").forEach((e)=>{
        e.addEventListener("click", (el) => {
          let container = el.target.closest(".product-variants");
          container.querySelectorAll(".size-btn").forEach((btn)=>{
            btn.classList.remove("active");
          });
          el.target.classList.add("active");
          // if(el.target.closest(".product-kit-form") == null) {
          //   const activeColor = this.querySelector(".product-variants .swatch-list .active");
          //   const activeSize = this.querySelector(".product-variants .size-btn.active");
          //   let selectedColor = activeColor.getAttribute("data-swatch-color"),
          //       selectedSize = activeSize.getAttribute("data-size-value");
          //   buildImageList(selectedColor, selectedSize);
          // }
        });
      });
      
      //rebuild gallery on swatch or size button click
      this.querySelectorAll('.product-variants').forEach((el)=>{
        el.addEventListener("click", (e) => {
          if (e.target.closest(".color-btn:not(.swatch-btn-kit)")){
            let index = parseInt(e.target.closest(".color-btn").getAttribute('data-index'));
            this.querySelectorAll("#variant-swatch-container .color-btn").forEach((e) =>{
              e.classList.remove("active");
            })
            e.target.closest(".color-btn").classList.add("active");
            //reset thumbnail gallery
            this.querySelector(".product-thumbnail-image-splide .splide__list").style.transform = "translateY(0)";
            if (this.querySelector(".product-variants .swatch-list .color-btn.active") != null){
              prodImages = [];
              let selectedColor = this.querySelector(".product-variants .swatch-list .active").getAttribute("data-swatch-color"),
                  selectedSize = this.querySelector(".product-variants .size-btn.active").getAttribute("data-size-value");
              this.data[index].node.media.edges.forEach((e)=>{
                let imgData = {image_alt: e.node.alt, image_color: selectedColor, image_url: e.node.previewImage.url}
                prodImages.push(imgData)
              })
              buildImageList(selectedColor, selectedSize);
              this.querySelector(".product-variants .size-btn.active").click();
              if (window.matchMedia("(max-width: 991px)").matches) {
                this._initZoom();
              }
            }
          }
        });
      });

      //open zoomed-in image on click
      this.querySelector("#hero-images-featured-interior").addEventListener("click", (e)=>{
        if (e.target.closest(".product-main-image")){
          if (popupMain) {
            popupMain.go(galleryMain.index);
          }
          document.documentElement.classList.add('product_images_popup_active');
        }
      });
    }

    _handleGalleryArrowClick(e) {
      let thumbPosition = 0;
      const target = e.currentTarget;

      this.galleryArrows.forEach((el)=> {
        el.classList.remove("hide-v");
      });

      let distance = (this.thumbContainer.querySelectorAll(".splide__slide")[0].getBoundingClientRect().height + 15) * 3;
      let maxDistance = this.thumbContainer.querySelector(".splide__list").offsetHeight - this.thumbContainer.querySelector(".splide__list").scrollHeight;
      if(target.classList.contains("arrow--prev")){
        thumbPosition = thumbPosition + distance > 0 ? 0 : thumbPosition + distance;
      }
      if(target.classList.contains("arrow--next")){
        thumbPosition = thumbPosition - distance < maxDistance ? maxDistance : thumbPosition - distance;
      }
      if (thumbPosition == 0) {
        this.arrowRight.classList.add("hide-v")
      }
      else if(thumbPosition == maxDistance){
        this.arrowNext.classList.add("hide-v");
      }
      this.thumbContainer.querySelector(".splide__list").style.transform = `translateY(${thumbPosition}px)`;
    }

    _initZoom() {
      const images = this.querySelectorAll('[data-zoom-image]');
      images.forEach((image) => {
        let initialDistance = 0;
        let scale = 1;

        function getDistance(touches) {
          const dx = touches[0].clientX - touches[1].clientX;
          const dy = touches[0].clientY - touches[1].clientY;
          return Math.sqrt(dx * dx + dy * dy);
        }

        image.addEventListener("touchstart", (event) => {
          if (event.touches.length === 2) {
            initialDistance = getDistance(event.touches);
          }
        }, false);

        image.addEventListener("touchmove", (event) => {
          if (event.touches.length === 2) {
            event.preventDefault(); // Prevent default zooming
            const newDistance = getDistance(event.touches);
            const zoomFactor = newDistance / initialDistance;
            scale *= zoomFactor;
            scale = Math.max(1, Math.min(scale, 5)); // Limit zoom scale
            image.style.transform = `scale(${scale})`;
            initialDistance = newDistance;
          }
        }, false);
      })
    }
  }

  customElements.define("comp-product-hero", CompProductHero);
}
